import React from 'react';
import ProjectLayout from '../Components/ProjectLayout';

import heroImg from '../assets/projects/keymotion/hero.png';
import editorImg from '../assets/projects/keymotion/editor.png';
import aiAssistantGif from '../assets/projects/keymotion/ai-assistant-intro.gif';
import cardStackGif from '../assets/projects/keymotion/card-stack.gif';

const Keymotion = () => {
  return (
    <ProjectLayout
      title="Keymotion"
      description={[
        'I founded and built keymotion.ai, an in-browser editor for AI motion graphics made for editors and motion designers.',
        'The product takes a prompt or image/video reference, drafts motion with AI, then lets you finish it in a real keyframe editor before export. I designed and shipped the full stack myself: browser motion editor, AI generation, template library, project files for After Effects, billing and credits.',
        <>
          Live at{' '}
          <a
            href="https://www.keymotion.ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            keymotion.ai
          </a>
        </>,
      ]}
      credits={['Product', 'AI Motion', 'Editor', 'Full Stack']}
    >
      <div className="pm-video">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src="/videos/keymotion-code-window-scroll.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="pm-section">
        <h2 className="pm-section__title">Generate</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          Describe an animation or attach a logo, still, or video reference. AI drafts
          a Motion IR scene graph instead of a black-box clip, so the result stays editable.
        </p>
      </div>
      <img className="pm-full" src={heroImg} alt="keymotion.ai homepage generate interface" />

      <div className="pm-section">
        <h2 className="pm-section__title">Edit</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          Finish motion in a real editor: layers, keyframes, easing, Essential Graphics,
          and a Premiere-style sequencer. Chat can apply surgical diffs without regenerating
          the whole piece.
        </p>
      </div>
      <img className="pm-full" src={editorImg} alt="Keymotion browser editor with timeline and Essential Graphics" />

      <div className="pm-section">
        <h2 className="pm-section__title">Templates</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          Thirty templates across kinetic type, lower thirds, logo reveals, transitions,
          callouts, backgrounds and social graphics for day-to-day edit workflows.
        </p>
      </div>
      <div className="pm-row">
        <img src={aiAssistantGif} alt="AI Assistant Intro template from keymotion.ai" />
        <img src={cardStackGif} alt="Card Stack template from keymotion.ai" />
      </div>

      <div className="pm-section">
        <h2 className="pm-section__title">Ship</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          Export MP4, MOV, GIF or PNG sequence from the browser. Studio unlocks After Effects
          and Premiere project files (.aep / .mogrt) from the same composition you already fixed,
          with Stripe billing and credit-based AI passes underneath.
        </p>
      </div>
    </ProjectLayout>
  );
};

export default Keymotion;
